import { RiseUserAction } from "@/types/RiseUserAction";
import { actionIsComplete } from "@/components/RiseAction/util";

// Move any actions in list that are completed to the bottom
export const sortActions = (actions: RiseUserAction[]) => {
  const completed = actions.filter((action) => actionIsComplete(action));
  const notCompleted = actions.filter((action) => !actionIsComplete(action));
  return [...notCompleted, ...completed];
};

export enum StrategyBoardState {
  SHOW_ACTIONS = "SHOW ACTIONS",
  NOT_READY = "NOT READY",
  SET_GOAL = "SET_GOAL",
  EMPTY = "EMPTY",
  NO_ASSIGNED_STUDENTS = "NO_ASSIGNED_STUDENTS",
}

export const getUserStrategyBoardState = (
  actionsCount: number,
  hiddenActionsCount: number,
  hasAssignedStudents: boolean,
  actionsReady: boolean,
): StrategyBoardState => {
  if (!hasAssignedStudents) return StrategyBoardState.NO_ASSIGNED_STUDENTS;
  if (actionsCount > 0) return StrategyBoardState.SHOW_ACTIONS;
  if (!actionsReady) return StrategyBoardState.NOT_READY;
  if (hiddenActionsCount > 0) return StrategyBoardState.SET_GOAL;

  return StrategyBoardState.EMPTY;
};

export const aggregateActions = (actions: RiseUserAction[]) => {
  let done = 0;
  let skipped = 0;
  let notDone = 0;
  for (const action of actions) {
    done += action.metrics?.doneCount || 0;
    skipped += action.metrics?.skippedCount || 0;
    notDone += action.metrics?.notDoneCount || 0;
  }

  const completed = done + skipped;
  const total = completed + notDone;
  return { done, skipped, total };
};
